import Vue from 'vue'
import Router from 'vue-router'
import auth from './auth'
import settings from './settings'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    auth,
    {
      path: '/',
      name: 'home',
      redirect: { name: 'users' },
      component: () => import(/* webpackChunkName: "home" */ '@/views/Home'),
      children: [
        {
          path: 'users',
          name: 'users',
          component: () =>
            import(/* webpackChunkName: "users" */ '@/views/Home/Users'),
        },
        {
          path: 'users/new',
          name: 'users.new',
          component: () =>
            import(
              /* webpackChunkName: "users" */ '@/views/Home/Users/UserDetails'
            ),
        },
        {
          path: 'users/:id',
          name: 'user.details',
          component: () =>
            import(
              /* webpackChunkName: "users" */ '@/views/Home/Users/UserDetails'
            ),
        },
        {
          path: 'interests',
          name: 'interests',
          component: () =>
            import(
              /* webpackChunkName: "interests" */ '@/views/Home/Interests'
            ),
        },
        {
          path: 'interests/new',
          name: 'interest.new',
          component: () =>
            import(
              /* webpackChunkName: "interests" */ '@/views/Home/Interests/InterestDetails'
            ),
        },
        {
          path: 'interests/:id',
          name: 'interest.details',
          component: () =>
            import(
              /* webpackChunkName: "interests" */ '@/views/Home/Interests/InterestDetails'
            ),
        },
        {
          path: 'age-groups',
          name: 'ageGroups',
          component: () =>
            import(
              /* webpackChunkName: "age-groups" */ '@/views/Home/AgeGroups'
            ),
        },
        {
          path: 'age-groups/new',
          name: 'ageGroup.new',
          component: () =>
            import(
              /* webpackChunkName: "age-groups" */ '@/views/Home/AgeGroups/AgeGroupDetails'
            ),
        },
        {
          path: 'age-group/:id',
          name: 'ageGroup.details',
          component: () =>
            import(
              /* webpackChunkName: "age-group" */ '@/views/Home/AgeGroups/AgeGroupDetails'
            ),
        },
        {
          path: 'tags',
          name: 'tags',
          component: () =>
            import(/* webpackChunkName: "tags" */ '@/views/Home/Tags'),
        },
        {
          path: 'tags/new',
          name: 'tags.new',
          component: () =>
            import(
              /* webpackChunkName: "tags" */ '@/views/Home/Tags/TagDetails'
            ),
        },
        {
          path: 'tags/:id',
          name: 'tag.details',
          component: () =>
            import(
              /* webpackChunkName: "tags" */ '@/views/Home/Tags/TagDetails'
            ),
        },
        {
          path: 'discoveries/new',
          name: 'discovery.new',
          component: () =>
            import(
              /* webpackChunkName: "discoveries" */ '@/views/Home/Discoveries/DiscoveryDetails'
            ),
        },
        {
          path: 'discoveries',
          name: 'discoveries',
          component: () =>
            import(
              /* webpackChunkName: "discoveries" */ '@/views/Home/Discoveries'
            ),
        },
        {
          path: 'discoveries/:id',
          name: 'discovery.details',
          component: () =>
            import(
              /* webpackChunkName: "discoveries" */ '@/views/Home/Discoveries/DiscoveryDetails'
            ),
        },
        {
          path: 'discovery-pages',
          name: 'discoveryPages',
          component: () =>
            import(
              /* webpackChunkName: "discoveryPages" */ '@/views/Home/DiscoveryPages'
            ),
        },
        {
          path: 'discovery-pages/new',
          name: 'discoveryPage.new',
          component: () =>
            import(
              /* webpackChunkName: "discoveryPages" */ '@/views/Home/DiscoveryPages/DiscoveryPageDetails'
            ),
        },
        {
          path: 'discovery-pages/:id',
          name: 'discoveryPage.details',
          component: () =>
            import(
              /* webpackChunkName: "discoveryPages" */ '@/views/Home/DiscoveryPages/DiscoveryPageDetails'
            ),
        },
        {
          path: 'quotes/new',
          name: 'quote.new',
          component: () =>
            import(
              /* webpackChunkName: "quotes" */ '@/views/Home/Quotes/QuoteDetails'
            ),
        },
        {
          path: 'quotes',
          name: 'quotes',
          component: () =>
            import(/* webpackChunkName: "quotes" */ '@/views/Home/Quotes'),
        },
        {
          path: 'quotes/:id',
          name: 'quote.details',
          component: () =>
            import(
              /* webpackChunkName: "quotes" */ '@/views/Home/Quotes/QuoteDetails'
            ),
        },
        {
          path: 'report-categories',
          name: 'reportCategories',
          component: () =>
            import(
              /* webpackChunkName: "report-categories" */ '@/views/Home/ReportCategories'
            ),
        },
        {
          path: 'report-categories/new',
          name: 'reportCategory.new',
          component: () =>
            import(
              /* webpackChunkName: "report-categories" */ '@/views/Home/ReportCategories/ReportCategoryDetails'
            ),
        },
        {
          path: 'report-categories/:id',
          name: 'reportCategory.details',
          component: () =>
            import(
              /* webpackChunkName: "report-categories" */ '@/views/Home/ReportCategories/ReportCategoryDetails'
            ),
        },
        {
          path: 'reports',
          name: 'reports',
          component: () =>
            import(/* webpackChunkName: "reports" */ '@/views/Home/Reports'),
        },
        settings,
        // {
        //   path: 'inbox',
        //   name: 'inbox',
        //   component: () =>
        //     import(/* webpackChunkName: "inbox" */ '@/views/Home/Inbox')
        // },
        // {
        //   path: 'content',
        //   name: 'content',
        //   component: () =>
        //     import(/* webpackChunkName: "content" */ '@/views/Home/Content')
        // },
        // {
        //   path: 'notification',
        //   name: 'notification',
        //   component: () =>
        //     import(
        //       /* webpackChunkName: "push-notification" */ '@/views/Home/Notification'
        //     )
        // }
      ],
    },
  ],
})
